import type { PermissionSelector } from "@/hooks/usePermission";

export const canViewGroupMembers: PermissionSelector = (x) => x.community.canListGroups;

export const canCreateHelpCategory: PermissionSelector = (x) => x.community.canCreateGroup && x.isAdmin;

export const canClone: PermissionSelector = (x) => x.community.canCreateGroup && x.isAdmin;
